<template>
    <div>
        <div class="client__header pa-2">
            <div class="d-flex align-center">
                <OBtnToolTipHeaderComp
                    v-if="!mobile"
                    :icono="mini ? 'mdi-arrow-right-bold-box' : 'mdi-arrow-left-bold-box'"
                    smsToolTip="Ocultar Menú"
                    @click="$emit('clickmini')"
                />
                <h1 :class="mobile ? 'app-title' : 'app-title ml-2'">
                    {{`BAJAS INVENTARIO (${total})`}}
                </h1>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-center client__header-block-second">
                <OSearchHeaderComp
                    label="Buscar"
                    v-model="search"
                    @entersearch="eSearchLowInventories()"
                />
            </div>
        </div>
        <div class="client__line-header" id="position-scroll"></div>
        <div class="d-flex justify-center flex-wrap">
            <div class="product__group-search d-flex justify-center pt-2 pl-2 pr-2">
                <div class="product__search" style="margin-right:2px">
                    <MTextFieldComp
                        label="Fecha expiración"
                        type="date"
                        :hideDetails="true"
                        v-model="expiration_date"
                    />
                </div>
                <div class="product__search" style="margin-left:2px">
                    <div
                        class="product__search-laboratories d-flex align-center pl-3"
                        @click="eOpenDialogProducts()"
                    >
                        <h2>Producto</h2>
                        <h1 class="app-subtitle">
                            {{productSearch.id==0 ? "Todos" : productSearch.name}}
                        </h1>
                    </div>
                </div>
            </div>
            <div class="product__group-search d-flex justify-center pt-2 pl-2 pr-2">
                <div class="product__search" style="margin-right:2px">
                    <MTextFieldComp
                        label="Inicio"
                        type="date"
                        :hideDetails="true"
                        :clearable="false"
                        v-model="dateOne"
                    />
                </div>
                <div class="product__search" style="margin-left:2px">
                    <MTextFieldComp
                        label="Fin"
                        type="date"
                        :hideDetails="true"
                        v-model="dateTwo"
                        :clearable="false"
                    />
                </div>
            </div>
        </div>
        <v-divider class="mt-2"></v-divider>
        <OLoaderDataComp
            class="mt-2"
            v-if="dialogLoaderData"
            smsLoaderData="Obteniendo Información"
        />
        <MNoDataComp
            smsNotData="SIN DATOS"
            class="ma-1"
            v-if="lowsInventories.length==0 && !dialogLoaderData && mobile"
        />
        <STableLowInventoriesComp
            v-if="!dialogLoaderData && !mobile"
            :lowsInventories="lowsInventories"
            :search="searchFilter"
            @clickdetail="eShowDetailProduct"
            @clickpurchase="eShowDetailPurchase"
            @clickreverse="eShowFormDelete"
            @clickdelete="eConfirmDeleteLot"
        />
        <div
            class="d-flex justify-center flex-wrap"
            v-if="!dialogLoaderData && mobile"
        >
            <SCardLowInventoyComp
                class="ma-2"
                :search="searchFilter"
                v-for="low_lot in lowsInventories"
                :key="low_lot.id"
                :low_lot="low_lot"
                @clickdetail="eShowDetailProduct(low_lot)"
                @clickpurchase="eShowDetailPurchase(low_lot)"
                @clickreverse="eShowFormDelete(low_lot)"
                @clickdelete="eConfirmDeleteLot(low_lot)"
            />
        </div>
        <v-divider
            class="mt-1"
            v-if="mobile && !dialogLoaderData && lowsInventories.length>0"
        ></v-divider>
        <SPaginationComp
            class="mt-2 mb-2"
            v-if="!dialogLoaderData && lowsInventories.length > 0"
            :condicionGo="currentPage < lastPage"
            :condicionBack="currentPage > 1"
            :titlePagination="'Pag. '+currentPage+' de '+lastPage"
            @clickback="eChangePage(false)"
            @clickgo="eChangePage(true)"
            @clickpage="eSearchForPage"
        />
        <SDialogSearchProductComp
            :valueDialog="dialogSearchProducts"
            v-model="productSearch.search"
            :productsList="productsList"
            ref="dialogproducts"
            :searchProduct="searchFilterProduct"
            :dialogLoaderData="productSearch.dialogLoaderData"
            @clickclose="eCloseSearchProducts()"
            @entersearch="eSearchProducts()"
            @clickproduct="eSelectProduct"
        />
        <SFormDeleteInventoryComp
            title="Revertir"
            :value="dialogFormInventory"
            :lot="lot"
            ref="forminventorycomp"
            @clickclose="eCloseFormLot()"
            @saveform="eConfirmDeleteInventory"
        />
        <SDetailProductComp
            :value="dialogProduct"
            :product="product"
            @clickclose="dialogProduct=false"
        />
        <SDetailPurchaseLotComp
            :value="dialogPurchase"
            :lot="lot"
            @clickclose="dialogPurchase=false"
        />
        <OSmsErrorComp
            :smsError="smsError"
            :value="dialogError"
            :actionError="actionError"
            :mobile="mobile"
            @click="eCloseError()"
        />
        <OSmsConfirmationComp
            :value="dialogConfirm"
            :smsConfirm="smsConfirm"
            :mobile="mobile"
            @clickno="eCloseDialogConfirm()"
            @clickyes="ePerformOperation()"
        />
        <OSmsActionComp
            :value="frameCorrect"
            :colorMessage="colorMessage"
            :smsAction="smsAction"
            :timeSucess="timeSucess"
            @click="mDataGeneralFrameTimeReset()"
        />
        <OOperationLoaderComp
            smsLoaderOperation="Realizando Operación"
            :value="dialogLoaderOperation"
        />
    </div>
</template>
<script>
import {
    MTextFieldComp,
    MNoDataComp
} from "../../components/molecules";
import {
    OSmsErrorComp,
    OSmsConfirmationComp,
    OSmsActionComp,
    OOperationLoaderComp,
    OBtnToolTipHeaderComp,
    OSearchHeaderComp,
    OLoaderDataComp
} from "../../components/organisms";
import {
    STableLowInventoriesComp,
    SDetailProductComp,
    SDetailPurchaseLotComp,
    SFormDeleteInventoryComp,
    SPaginationComp,
    SCardLowInventoyComp,
    SDialogSearchProductComp
} from "../../components/species";
import {
    rulesMixin,
    responseServerMixin,
    animationScrollMixin,
    dataGeneralCompsMixin,
    userMixin,
    datesMixin
} from "../../mixins";
import {
    LowInventory,
    Product
} from "../../models";
export default {
    mixins: [
        rulesMixin,
        responseServerMixin,
        animationScrollMixin,
        dataGeneralCompsMixin,
        userMixin,
        datesMixin
    ],
    components: {
        OSmsErrorComp,
        OSmsConfirmationComp,
        OSmsActionComp,
        OOperationLoaderComp,
        OBtnToolTipHeaderComp,
        OSearchHeaderComp,
        MTextFieldComp,
        STableLowInventoriesComp,
        SDetailProductComp,
        SDetailPurchaseLotComp,
        SFormDeleteInventoryComp,
        OLoaderDataComp,
        MNoDataComp,
        SPaginationComp,
        SCardLowInventoyComp,
        SDialogSearchProductComp
    },
    props: {
        mini: Boolean
    },
    data: () => ({
        search: "",
        expiration_date: "",
        dialogSearchProducts: false,
        productSearch: {
            id: 0,
            name: "Todos",
            dialogLoaderData: false,
            search: ""
        },
        productsList: [{ id: 0, product: "Todos" }],
        lowsInventories: [],
        dateOne: "",
        dateTwo: "",
        dialogPurchase: false,
        dialogProduct: false,
        product: {},
        lot: {},
        dialogFormInventory: false,
        quantity: 0,
        idLowInventory: 0
    }),
    computed: {
        searchFilter: function() {
            return this.search !== null ? this.search : "";
        },
        searchFilterProduct: function() {
            return this.productSearch.search !== null ? this.productSearch.search : "";
        }
    },
    methods: {
        eCloseError() {
            if (this.noAccess.withoutAutorization)
                this.mDataGeneralActionWithOutAutorization();
            else {
                this.dialogError = false;
                this.dialogFormInventory = true;
            }
        },
        processErrorServer(error) {
            this.dialogLoaderOperation = false;
            this.noAccess = this.mResponseServeAutorization(error);
            this.smsError = this.mResposeServerSmsError(error);
            this.actionError = this.mResponseServeAction(error);
            this.dialogError = true;
        },
        async getLowInventories(page, search, dateExpiration, dateOne, dateTwo, idProduct) {
            this.dialogLoaderData = true;
            try {
                const response = await LowInventory.getLowInventory(page, search, dateExpiration, dateOne, dateTwo, idProduct);
                this.lowsInventories = response.data;
                this.lastPage = response.last_page;
                this.currentPage = response.current_page;
                this.total = response.total;
                this.dialogLoaderData = false;
            } catch (error) {
                this.processErrorServer(error);
            }
        },
        validateDateRange() {
            if ((this.dateOne !== "" && this.dateTwo === "") || (this.dateOne === "" && this.dateTwo !== "")) {
                this.mDataGeneralShowSmsAction(["Error Fechas", "Debe selecciona ambas fechas"], "error");
                return false;
            }
            if (this.dateOne > this.dateTwo) {
                this.mDataGeneralShowSmsAction(["Error Fechas", "La fecha de inicio no puede ser mayor a la fecha final"], "error");
                return false;
            }
            return true;
        },
        eSearchLowInventories() {
            if (this.validateDateRange()) {
                if (this.mRuleEmptyField(this.search)) this.search = "";
                this.getLowInventories(1, this.search, this.expiration_date, this.dateOne, this.dateTwo, this.productSearch.id);
            }
        },
        eShowDetailProduct(inventory) {
            this.product = inventory.product;
            this.dialogProduct = true;
        },
        eShowDetailPurchase(inventory) {
            if (inventory.id_purchase !== 0) {
                this.lot = inventory;
                this.dialogPurchase = true;
            } else this.mDataGeneralShowSmsAction(
                ["Sin Registro de Compra", "El lote no fue registrado por compras"], "error");
        },
        eShowFormDelete(lot) {
            this.lot = lot;
            this.dialogFormInventory = true;
        },
        eConfirmDeleteInventory(info) {
            this.quantity = parseInt(info.quantity);
            this.dialogFormInventory = false;
            const smsConfirm = [`¿Está seguro de revertir la cantidad de: ${info.quantity}
                , del producto: ${this.lot.product.product}?`]
            this.mDataGeneralConfirmForm(info.state, smsConfirm);
        },
        eCloseFormLot() {
            this.$refs.forminventorycomp.resetForm();
            this.dialogFormInventory = false;
        },
        eCloseDialogConfirm() {
            this.idLowInventory = 0;
            this.dialogConfirm = false;
            this.dialogFormInventory = true;
        },
        async reverseInventory() {
            const parameters = {
                "id": this.lot.id,
                "quantity": this.quantity
            }
            try {
                await LowInventory.reverseInventory(parameters);
                const index = this.lowsInventories.indexOf(this.lot);
                if (this.lot.quantity === this.quantity) {
                    this.lowsInventories.splice(index, 1);
                    this.total -= 1;
                } else this.lowsInventories[index].quantity -= this.quantity;
                this.$refs.forminventorycomp.resetForm();
                this.dialogLoaderOperation = false;
                this.mDataGeneralShowSmsAction(["Operación Exitosa", "Se revertió el inventario seleccionado"], "success");
            } catch(error) {
                this.processErrorServer(error);
            }
        },
        async deleteLowInventory() {
            try {
                await LowInventory.deleteLowInventory({id: this.idLowInventory});
                const index = this.lowsInventories.indexOf(this.lot);
                this.lowsInventories.splice(index, 1);
                this.idLowInventory = 0;
                this.dialogLoaderOperation = false;
                this.mDataGeneralShowSmsAction(["Operación Exitosa", "Se eliminó el inventario seleccionado"], "success");
            } catch(error) {
                this.processErrorServer(error);
            }
        },
        ePerformOperation() {
            this.dialogConfirm = false;
            this.dialogLoaderOperation = true;
            if (this.idLowInventory !== 0)
                this.deleteLowInventory();
            else this.reverseInventory();
        },
        eCloseSearchProducts() {
            this.dialogSearchProducts = false;
            setTimeout(() => {
                this.productSearch.search = "";
                this.productsList = [{ id: 0, product: "Todos" }];
            }, 150)
        },
        async eSearchProducts() {
            this.productSearch.dialogLoaderData = true;
            if (this.mRuleEmptyField(this.productSearch.search)) this.productSearch.search = "";
            this.productsList = [{ id: 0, product: "Todos" }];
            try {
                const response = await Product.getProducts(1, this.productSearch.search, 1, 2, 0, 0);
                response.data.forEach(product => {
                    this.productsList.push(product);
                });
                this.productSearch.dialogLoaderData = false;
            } catch(error) {
                this.dialogSearchProducts = false;
                this.processErrorServer(error);
            }
        },
        eOpenDialogProducts() {
            this.dialogSearchProducts = true;
            setTimeout(() => {
                this.$refs.dialogproducts.activateFocus();
            }, 150);
        },
        eSelectProduct(product) {
            this.productSearch.id = product.id;
            this.productSearch.name = product.product;
            this.eCloseSearchProducts();
        },
        eChangePage(isGo) {
            if (isGo) ++this.currentPage;
            else --this.currentPage;
            const time = this.mAnimationScrollTime();
            this.$vuetify.goTo(this.mAnimationScrollGetTopNode(), this.mAnimationScrollOptions(time));
            setTimeout(() => {
                this.getLowInventories(this.currentPage, this.search, this.expiration_date, this.dateOne, this.dateTwo, this.productSearch.id);
            }, time);
        },
        eSearchForPage(page) {
            const isNotValidPage = this.mDataGeneralSearchForPage(page, this.mRuleNumberInteger(page));
            if (isNotValidPage) {
                const time = this.mAnimationScrollTime();
                this.$vuetify.goTo(this.mAnimationScrollGetTopNode(), this.mAnimationScrollOptions(time));
                setTimeout(() => {
                    this.getLowInventories(page, this.search, this.expiration_date, this.dateOne, this.dateTwo, this.productSearch.id);
                }, time);
            }
        },
        handleKeyUpLowInventorie(event) {
            if (!this.mobile) {
                const actionKeyBoard = this.mDataGeneralActionKeyboard(event.keyCode);
                if (actionKeyBoard === 0) this.eCloseDialogConfirm();
                if (actionKeyBoard === 1) this.ePerformOperation();
                if (actionKeyBoard === 2) this.eCloseError();
            }
        },
        eConfirmDeleteLot(lot) {
            this.lot = lot;
            this.idLowInventory = lot.id;
            this.smsConfirm = [`¿Está seguro(a) de eliminar todo el lote de: ${lot.product.product}?`];
            const time = this.mAnimationScrollTime();
            this.$vuetify.goTo(0, this.mAnimationScrollOptions(time));
            setTimeout(() => {
                this.dialogConfirm = true;
            }, time);
        }
    },
    mounted() {
        if (window.innerWidth <= 600) this.mobile = true;
        if (this.mUserSaveHeader(this.mDateSystem(false))) {
            if (this.mUserCategorie() === "0") {
                window.addEventListener('keyup', this.handleKeyUpLowInventorie);
                this.dialogLoaderData = false;
            } else this.$router.replace('/home');
        } else this.$router.replace('/login');
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeyUpLowInventorie);
    }
}
</script>